// Homepage Hero — product surface (Connect / Activate / Automate): tab rotation, chat replay, dot field, typing effect.
import jQuery from "jquery";

jQuery(function ($) {
	'use strict';

	$('html').addClass('p360-js');

	var $panel = $('#p360HeroPanel');
	if (!$panel.length) {
		return;
	}

	var reduceMotion =
		window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	// Tab rotation
	(function () {
		var $states = $panel.find('.p360-hp-state');
		var $tabs = $panel.find('.p360-hp-tab');
		var $product = $('#p360HpProduct');
		var $surface = $('#p360HpTitle');
		var $bar = $('#p360HpBar');

		if (!$states.length || !$tabs.length) {
			return;
		}

		var PRODUCTS = ['Connect', 'Activate', 'Automate'];
		var SURFACES = ['Engagement', 'Analytics', 'AI'];
		var HOLD_MS = [5500, 5500, 7000];

		var current = 0;
		var timer = null;

		function resetBar(run) {
			if (!$bar.length) {
				return;
			}
			$bar.css({ transition: 'none', height: '0%' });
			$bar[0].offsetHeight;
			if (run && !reduceMotion) {
				$bar.css({
					transition: 'height ' + HOLD_MS[current] + 'ms linear',
					height: '100%',
				});
			}
		}

		function show(index, run) {
			current = ((index % $states.length) + $states.length) % $states.length;

			$states.each(function (i) {
				$(this).toggleClass('is-on', i === current);
			});

			$tabs.each(function (i) {
				$(this)
					.toggleClass('is-on', i === current)
					.attr('aria-selected', i === current ? 'true' : 'false');
			});

			if ($product.length) {
				$product.text(PRODUCTS[current]);
			}
			if ($surface.length) {
				$surface.text(SURFACES[current]);
			}

			resetBar(run);
		}

		function stop() {
			if (timer) {
				clearTimeout(timer);
			}
			timer = null;
		}

		function play() {
			if (reduceMotion) {
				return;
			}
			stop();
			resetBar(true);
			timer = setTimeout(function tick() {
				show(current + 1, true);
				timer = setTimeout(tick, HOLD_MS[current]);
			}, HOLD_MS[current]);
		}

		$tabs.on('click', function () {
			show($tabs.index(this), true);
			play();
		});

		$panel.on('mouseenter', function () {
			stop();
			if ($bar.length) {
				var currentHeight = $bar.css('height');
				$bar.css({ transition: 'none', height: currentHeight });
			}
		});
		$panel.on('mouseleave', function () {
			play();
		});

		$(document).on('visibilitychange', function () {
			if (document.hidden) {
				stop();
			} else {
				play();
			}
		});

		show(0, false);
		play();
	})();

	// Connect panel: message thread replay
	(function () {
		var $state = $panel.find('.p360-hp-state[data-st="0"]');
		if (!$state.length) {
			return;
		}

		var $rows = $state.find('.p360-ct-row');
		var $typing = $state.find('.p360-ct-typ');
		var timers = [];
		var wasOn = false;

		function at(ms, fn) {
			timers.push(setTimeout(fn, ms));
		}

		function enter($el) {
			$el.addClass('in');
			requestAnimationFrame(function () {
				$el.addClass('show');
			});
		}

		function leave($el) {
			$el.removeClass('show');
			at(260, function () {
				$el.removeClass('in');
			});
		}

		function playThread() {
			timers.forEach(clearTimeout);
			timers = [];

			$rows.removeClass('in show');
			$typing.removeClass('in show');

			if (reduceMotion) {
				$rows.addClass('in show');
				return;
			}

			at(350, function () {
				enter($rows.eq(0));
			});
			at(1150, function () {
				enter($typing);
			});
			at(2000, function () {
				leave($typing);
			});
			at(2150, function () {
				enter($rows.eq(1));
			});
			at(2950, function () {
				enter($rows.eq(2));
			});
		}

		new MutationObserver(function () {
			var isOn = $state.hasClass('is-on');
			if (isOn && !wasOn) {
				playThread();
			}
			wasOn = isOn;
		}).observe($state.get(0), { attributes: true, attributeFilter: ['class'] });

		if ($state.hasClass('is-on')) {
			wasOn = true;
			playThread();
		}
	})();

	// Activate panel: build the 114-dot field
	(function () {
		var $field = $('#p360AvDots');
		if (!$field.length) {
			return;
		}

		var TOTAL_DOTS = 114;
		var html = '';

		for (var i = 0; i < TOTAL_DOTS; i++) {
			var isOn = (i * 7919) % 100 < 26;
			html += '<i class="' + (isOn ? 'on' : '') + '"></i>';
		}

		$field.html(html);
	})();

	// Automate panel: typed prompt
	(function () {
		var $state = $panel.find('.p360-hp-state[data-st="2"]');
		var $out = $('#p360AgType');
		if (!$state.length || !$out.length) {
			return;
		}

		var PROMPT = 'What do I need to know before my call with Dr. S. Mayer?';
		var typeTimer = null;
		var wasOn = false;

		function typeOut() {
			clearTimeout(typeTimer);
			$state.removeClass('is-typed');

			if (reduceMotion) {
				$out.text(PROMPT);
				$state.addClass('is-typed');
				return;
			}

			$out.text('');
			var i = 0;

			(function step() {
				$out.text(PROMPT.slice(0, ++i));
				if (i < PROMPT.length) {
					typeTimer = setTimeout(step, 17);
				} else {
					$state.addClass('is-typed');
				}
			})();
		}

		new MutationObserver(function () {
			var isOn = $state.hasClass('is-on');
			if (isOn && !wasOn) {
				typeOut();
			}
			wasOn = isOn;
		}).observe($state.get(0), { attributes: true, attributeFilter: ['class'] });

		if ($state.hasClass('is-on')) {
			wasOn = true;
			typeOut();
		}
	})();

	// Hero background parallax
	(function () {
		if (reduceMotion) {
			return;
		}

		var $items = $('[data-parallax]');
		if (!$items.length) {
			return;
		}

		var pointerX = 0;
		var pointerY = 0;
		var ticking = false;

		function apply() {
			var scrollY = window.scrollY || 0;
			$items.each(function () {
				var factor = parseFloat($(this).attr('data-parallax')) || 0;
				var x = pointerX * factor * 40;
				var y = scrollY * -factor + pointerY * factor * 40;
				$(this).css('transform', 'translate3d(' + x + 'px,' + y + 'px,0)');
			});
		}

		function onScroll() {
			if (ticking) {
				return;
			}
			ticking = true;
			requestAnimationFrame(function () {
				apply();
				ticking = false;
			});
		}

		$(window).on('scroll', onScroll);

		var $hero = $('.p360-hero');
		if ($hero.length) {
			$hero.on('pointermove', function (e) {
				var rect = this.getBoundingClientRect();
				pointerX = (e.clientX - rect.left) / rect.width - 0.5;
				pointerY = (e.clientY - rect.top) / rect.height - 0.5;
				apply();
			});
		}

		apply();
	})();
});